import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "../../../../contexts/I18nProvider";
import { selectHasPaid } from "../../../../redux/selectors/hasPaidSelectors";
import { Lock, Search } from "lucide-react";
import { Label } from "../../../../components/ui/label";
import { Switch } from "../../../../components/ui/switch";
import { Input } from "../../../../components/ui/input";
import {
  setCurrentPage,
  setSearchQuery,
} from "../../../../redux/slices/filterSlice";
import { applyClafricaToText } from "../../../../lib/clafrica";

function SentencesSearchInput({ variant = "default" }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const hasPaid = useSelector(selectHasPaid);

  const { searchQuery } = useSelector((state) => state.filters);
  const isToolbar = variant === "toolbar";
  const [clafricaEnabled, setClafricaEnabled] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("clafrica_enabled");
    if (stored !== null) {
      setClafricaEnabled(stored === "true");
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("clafrica_enabled", String(clafricaEnabled));
  }, [clafricaEnabled]);

  return (
    <div className="flex gap-2 flex-col w-full">
      <div className="flex items-center justify-between gap-2">
        {!isToolbar && (
          <Label htmlFor="items-per-page" className="flex gap-1">
            Sentences {!hasPaid && <Lock size={12} />}
          </Label>
        )}
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <span>Clafrica</span>
          <Switch
            checked={clafricaEnabled}
            onCheckedChange={setClafricaEnabled}
            aria-label="Toggle Clafrica shortcuts"
          />
        </div>
      </div>
      <div className="relative w-full">
        {isToolbar && (
          <Search className="absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
        )}
        <Input
          type="text"
          className={`bg-white polyglot-search-input ${
            isToolbar ? "pl-9 h-11" : ""
          }`}
          placeholder={t('polyglot.searchPlaceholder')}
          value={searchQuery}
          onChange={(e) => {
            const rawValue = e.target.value;
            const nextValue = clafricaEnabled
              ? applyClafricaToText(rawValue, !/\s$/.test(rawValue))
              : rawValue;
            dispatch(setSearchQuery(nextValue));
            dispatch(setCurrentPage(1));
          }}
        />
      </div>
      {!hasPaid && (
        <div className="flex justify-start">
          <a
            href="/pricing"
            className="polyglot-subscribe-link rounded-full px-3 py-1 text-xs shadow"
          >
            {t('polyglot.freeSearchLimited')}
          </a>
        </div>
      )}
    </div>
  );
}

export default SentencesSearchInput;
